import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { TokenService } from './token.service';
import { ProductionReason } from '../../models/production-reason.model';

@Injectable({
  providedIn: 'root',
})
export class ProductionService {
  apiUrl = environment.API_URL + 'internal/';

  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService,
  ) {}

  getCustomerHeader() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.tokenService.getComponentCodeToken(),
      'Accept-Language': 'pt-BR',
    });
  }

  public searchPlaces(placeDescription: string): Observable<any> {
    const url = this.apiUrl + 'production/v2/places/search';

    const body = {
      filter: {
        placeDescription,
      },
      page: 1,
      pageSize: 100000,
    };

    const headers = this.getCustomerHeader();

    return this.httpClient.post<any>(url, body, { headers });
  }

  public getProductionReasons(): Observable<ProductionReason[]> {
    const url = `${this.apiUrl}production/v2/production-reasons`;
    const headers = this.getCustomerHeader();

    return this.httpClient.get<ProductionReason[]>(url, { headers });
  }
}
